import { useEffect } from 'react'

/**
 * A slide-over panel, anchored right.
 *
 * A drawer rather than a modal, deliberately: what goes in here is read
 * *against* the row it belongs to, and someone logging a third reminder wants
 * the table still visible while they do it. A modal blanks out exactly the
 * context they are working from.
 *
 * Escape and the backdrop both close. Nothing in a drawer is irreversible —
 * anything that is belongs in a Modal with `dismissible={false}`.
 */
export default function Drawer({ title, subtitle, children, summary, toolbar, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === 'Escape' && onClose()
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onClose])

  return (
    <>
      <div className="drwbk" onClick={onClose} />
      <aside className="drw" role="dialog" aria-modal="true" aria-label={title}>
        <div className="drw-h">
          <div>
            <div className="drw-t">{title}</div>
            {subtitle && <div className="drw-s">{subtitle}</div>}
          </div>
          <button className="xbtn" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        {summary && <div className="drw-sum">{summary}</div>}

        {/* A fixed slot above the scrolling body — filters, sort, a
            bulk-action button — anything that should stay put while only
            the list underneath moves. Optional: a drawer with nothing to
            pin here (ActivityDrawer) just omits it. */}
        {toolbar && <div className="drw-toolbar">{toolbar}</div>}

        <div className="drw-b">{children}</div>
      </aside>
    </>
  )
}
